<template>
    <div class="card">
        <div v-if="this.$slots.header" class="card-header">
            <slot name="header"></slot>
        </div>
        <div :class="bodyClass">
            <slot></slot>
        </div>
        <div v-if="this.$slots.footer" class="card-footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    bodyClass: {
      type: String,
      default: "card-body"
    }    
  }
}
</script>